import { NotificationProvider } from "@circle-react-shared/Notifications/NotificationContext";
import { ModalManagerProvider } from "@circle-react/components/Layout/ModalManagerProvider";
import { ChatRoomsContextProvider } from "@circle-react/hooks/chatsV2/useChatsV2Api";
import { UnreadChatThreadsProvider } from "@circle-react/hooks/chatsV2/useUnreadChatThreads";

import { MasqueradeContextProvider } from "../contexts/masqueradeContext";
import { OtpChallengeProvider } from "../contexts/OtpChallengeContext";
import { SpaceNotificationsProvider } from "../contexts/sidebarNotificationsContext";

const Providers = [
  ChatRoomsContextProvider,
  SpaceNotificationsProvider,
  UnreadChatThreadsProvider,
  ModalManagerProvider,
  MasqueradeContextProvider,
  NotificationProvider,
  OtpChallengeProvider,
];

export const MultiContextProvider = ({ children }: any) =>
  Providers.reduceRight(
    (acc, Provider) => <Provider>{acc}</Provider>,
    children,
  );
